import { Component, OnInit, ViewChild } from "@angular/core";
import { UserBehaviorService } from "../../services/user-behavior/user-behavior.service";
import { MatSort, MatTableDataSource } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-user-behavior",
  templateUrl: "./user-behavior.component.html",
  styleUrls: ["./user-behavior.component.scss"],
})
export class UserBehaviorComponent implements OnInit {
  loading = true;
  users = [];
  dataSource;

  constructor(
    private userBehaviorService: UserBehaviorService,
    private router: Router
  ) {}

  displayedColumns = [
    "name",
    "firstName",
    "email",
    "userId",
    "registrationDate",
    "activationDate",
    "lastLogin",
    "countOwnedProjects",
    "countSharedProjects",
    "jiraSync",
  ];

  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.userBehaviorService
      .getAllUsers()
      .then((response) => {
        this.users = response.UserResponse.users;
        this.createDataSource(this.users);
        this.dataSource.sort = this.sort;
      })
      .catch((error) => {});
  }

  createDataSource(users) {
    this.loading = true;

    this.dataSource = new MatTableDataSource([]);
    let dataObjects = this.dataSource.data;
    users.forEach((element) => {
      dataObjects.push({
        name: element.lastName,
        firstName: element.firstName,
        email: element.email,
        userId: element._id,
        registrationDate: element.created_at
          ? new Date(element.created_at)
          : undefined,
        activationDate: element.activated_at
          ? new Date(element.activated_at)
          : undefined,
        lastLogin: element.last_action_at
          ? new Date(element.last_action_at)
          : undefined,
        countOwnedProjects: element.ownedProjectsCount,
        countSharedProjects: element.participatingProjectsCount,
        jiraSync: element.syncedProjectsCount,
      });
    });
    this.dataSource.data = dataObjects;
    this.loading = false;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  itemClicked(row) {
    // console.log(row);
    // console.log(row.userId);
    this.router.navigate(["/user-detail/", row.userId]);
  }

  projectOverviewClicked() {
    this.router.navigate(["/project-overview-admin"]);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/user-behavior/user-behavior.component.ts